/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListMessage } from '../../models/api-response-list-message';
import { ForwardMessage } from '../../models/forward-message';

export interface ForwardMessage$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ForwardMessage
}

export function forwardMessage(http: HttpClient, rootUrl: string, params: ForwardMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListMessage>> {
  const rb = new RequestBuilder(rootUrl, forwardMessage.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListMessage>;
    })
  );
}

forwardMessage.PATH = '/v1/api/ui/message/forward';
